import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none",
  viewBox: "0 0 48 49"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_1206_652638)\"><rect width=\"48\" height=\"48\" y=\"48.5\" fill=\"#E6E6E6\" rx=\"24\" transform=\"rotate(-90 0 48.5)\"></rect><path fill=\"#CCC\" d=\"M42.094 49.672a1.4 1.4 0 0 1-1.218.703H7.126a1.406 1.406 0 0 1-1.217-2.11c2.677-4.628 6.803-7.946 11.618-9.52a12.656 12.656 0 1 1 12.947 0c4.815 1.574 8.94 4.892 11.618 9.52a1.4 1.4 0 0 1 .002 1.407\"></path></g><defs><clipPath id=\"clip0_1206_652638\"><rect width=\"48\" height=\"48\" y=\"48.5\" fill=\"#fff\" rx=\"24\" transform=\"rotate(-90 0 48.5)\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }